import { shopPrefix } from '../../../config';
import { http } from '../../axios';
import { RenewalType } from '../../../shop/renewals/utils/renewalTableTileTypes';

export interface EditRenewalType {
    includedProductIds: string[];
    targetType: RenewalType;
}

export interface EditAllRenewalType {
    excludedProductIds: string[];
    targetType: RenewalType;
}

const endpointEdit = `${shopPrefix}/v1/subscription-management/renewals/types`;
const endpointEditAll = `${shopPrefix}/v1/subscription-management/renewals/types/all`;

export const editRenewalType = (data: EditRenewalType) => {
    return http.post<void>(endpointEdit, data).then(response => response.data);
};

export const editAllRenewalType = (data: EditAllRenewalType) => {
    return http.post<void>(endpointEditAll, data).then(response => response.data);
};
